export enum RecruiterType {
    Agency = 'agency',
    Individual = 'individual',
}
